/**
 * Reset all form elements to their default state
 */
export function resetAllForms() {
    document.querySelectorAll('.form-wrapper').forEach((wrapper) => {
        wrapper.querySelectorAll('input[type="text"], input[type="email"], textarea').forEach((element) => {
            element.value = '';
        });

        wrapper.querySelectorAll('select').forEach((select) => {
            if (select.options.length > 0) {
                select.value = select.options[0].value;
            }
        });

        wrapper.querySelectorAll('input[type="checkbox"], input[type="radio"]').forEach((element) => {
            element.checked = false;
        });

        const modelTypeInput = document.getElementById('model-type');
        if (modelTypeInput) modelTypeInput.value = '';

        const hoursInput = document.getElementById('hours');
        if (hoursInput) hoursInput.value = '500';

        let textOverlays = document.querySelectorAll('.text-overlay');
        textOverlays.forEach((textOverlay) => {
            textOverlay.classList.remove('active');
        });
    });
    
    // Reset currency-specific icon IDs back to base IDs
    ['icon_1', 'icon_4'].forEach(baseId => {
        const dollarVersion = document.querySelector('#' + baseId + '_dollar');
        const euroVersion = document.querySelector('#' + baseId + '_euro');
        
        if (dollarVersion) dollarVersion.id = baseId;
        if (euroVersion) euroVersion.id = baseId;
    });
}